<template>
  <span class="about">
    <section class="intro">
      <h2 class="hello text-title-second">Hello! </h2>
      <p class="main-text text-description"
        v-html="
          `I’m an artist, web developer and foraging nerd. In my art practice I seek to make digital tools that provide agency, build community, and connect us to the natural world. I also make interactive projects—field guides, video games and experiences—that draw attention to the absurdity and surrealism of digital spaces, in an attempt to reveal the hidden ways in which the web shapes our physical realities.<br><br>I am currently learning about regenerative food systems like foraging and seed saving, and am excited to learn about new ways to consider technology and build connections between virtual and natural systems.`"
      ></p>
      <div class="detail-blocks">
        <div class="detail-block wide">
          <h2 class="type text-caps">Contact</h2>
          <a class="link email text-description" :href="'mailto:' + email">
            <h3 class="value">{{email}}</h3>
          </a>
          <!-- <h3 class="value phone text-description">510.717.0590</h3> -->
        </div>
        <!-- <div class="detail-block">
          <h2 class="type text-caps">Info</h2>
          <a :href="`${publicPath}Lucas_Drummond_Resume_2019.pdf`" class="resume value link text-description" target="_blank">Resume -> </a>
        </div> -->
        <div class="detail-block">
          <h2 class="type text-caps">Media</h2>
          <ul class="value media">
            <a class="link text-sub-caption" href="https://www.linkedin.com/in/lucasdrummondconnect">
              <img src="@/assets/linkedin_logo.png" /> 
            </a>
            <a class="link text-sub-caption" href="https://github.com/ldrummond">
              <img src="@/assets/github_logo.png" /> 
            </a>
          </ul>
        </div>
      </div>
    </section>
    <div class="profile-pic">
      <ResponsiveImage 
        src="/lucas-artist.png"
        alt="Portrait of the artist as a young man"
      />
    </div>
    <!-- <div class="copyright">Site <i class="fa fa-copyright" style="color: #555"></i> 2018 Lucas Drummond </div> -->
  </span>
</template>

<script>
import ResponsiveImage from '../components/ResponsiveImage';

export default {
  name: 'About',
  props: ['siteMeta', 'projectsMeta'],
  components: {
    ResponsiveImage
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      email: this.siteMeta.email || 'ldrummond.contact@gmail.com',
      phone: this.siteMeta.phone || '510.717.0590',
    }
  },
}
</script>

<style lang="sass" scoped>
@import '../assets/partials/vars'

.about
  margin-top: 10rem
  display: flex
  flex-wrap: wrap
  width: 100%
  justify-content: space-between

  .intro
    max-width: 550px

  .profile-pic
    display: flex
    margin-bottom: 3rem
    background: black 
    margin: 0 -5%
    width: 110%
    .image
      margin: auto
      width: 300px
      margin-bottom: 3rem

  .hello
    margin-bottom: 3rem

  .main-text
    margin-bottom: 5rem

  .detail-blocks
    width: 100%
    display: flex
    flex-wrap: wrap
    justify-content: space-between
    margin-bottom: 3rem

    .detail-block
      width: 50%
      margin-bottom: 2rem
      &.wide
        width: 100%

      .type

      .value
        max-width: 100%
    
      .link
        &:hover
          color: $tertiary-color

      .email
      
      .media
        display: flex
        align-items: flex-end
        margin-top: 0.4rem
        .link
          margin-right: 10px
          text-decoration: none
          width: 2rem
          background: none
          img
            width: 100%
            opacity: 0.8
            display: inherit

/* For Desktop */
@media only screen and (min-width: 768px)
  .about
    margin-top: 0
    .profile-pic
      background: none 
      margin: 0
      width: 30%
      
    .detail-blocks
      .detail-block
        width: 50%
        margin-bottom: 3rem

</style>
